import React, { useState, useEffect } from 'react';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);

  // Function to fetch dashboard statistics
  const fetchDashboardStats = async () => {
    try {
      setError(null);
      const token = localStorage.getItem('token');
      
      const response = await fetch('/api/stats/dashboard', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      setStats(data);
      setLastUpdated(new Date());
      setLoading(false);
    } catch (error) {
      console.error('Erreur lors du chargement des statistiques:', error);
      setError(error.message);
      setLoading(false);
    }
  };

  // Load stats on component mount
  useEffect(() => {
    fetchDashboardStats();
  }, []);

  // Auto-refresh every 30 seconds
  useEffect(() => {
    const interval = setInterval(fetchDashboardStats, 30000);
    return () => clearInterval(interval);
  }, []);

  // Loading state
  if (loading) {
    return (
      <div className="dashboard">
        <div className="loading-stats">
          <div className="loading-spinner"></div>
          <p>Chargement des statistiques...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="dashboard">
        <div className="error-stats">
          <p>Erreur lors du chargement des statistiques</p>
          <small>{error}</small>
          <button onClick={fetchDashboardStats} className="btn btn-secondary">
            Réessayer
          </button>
        </div>
      </div>
    );
  }

  // Calculate derived stats from API data
  const roomStats = stats?.rooms || {};
  const reservationStats = stats?.reservations || {};
  
  const occupancyRate = roomStats.occupancyRate || 0;
  const totalRooms = roomStats.total || 0;
  const occupiedRooms = (roomStats.occupied || 0) + (roomStats.reserved || 0);
  
  // Calculate revenue (basic calculation for demo)
  const avgRoomRate = 120; // Average room rate in EUR
  const revenueToday = (roomStats.occupied || 0) * avgRoomRate;
  
  const arrivalsToday = reservationStats.checkins_today || 0;
  const departurestoday = reservationStats.checkouts_today || 0;

  return (
    <div className="dashboard">
      <div className="stat-card occupancy">
        <h3>Taux d'Occupation</h3>
        <div className="value">
          {occupancyRate}%
        </div>
        <small>
          {occupiedRooms}/{totalRooms} chambres
        </small>
      </div>
      
      <div className="stat-card revenue">
        <h3>Revenus Estimés</h3>
        <div className="value">
          €{revenueToday.toLocaleString()}
        </div>
        <small>Facturations du jour</small>
      </div>
      
      <div className="stat-card arrivals">
        <h3>Arrivées</h3>
        <div className="value">
          {arrivalsToday}
        </div>
        <small>Check-ins prévus</small>
      </div>
      
      <div className="stat-card departures">
        <h3>Départs</h3>
        <div className="value">
          {departurestoday}
        </div>
        <small>Check-outs prévus</small>
      </div>
    </div>
  );
}

export default Dashboard;